export const getApplicantNumber = (searchParams: URLSearchParams) => {
  const applicantNumberString = searchParams.get('applicantNumber');
  const applicantNumber = applicantNumberString ? parseInt(applicantNumberString) : 0;

  return applicantNumber;
};
